import { ACTION_TYPES, STATUS_TYPES, Story } from '@shared/api/types/story';

export const magicstoreProvidaoExclusive5000Giveaway: Story = {
  id: 'magicstore-providao-exclusive-5000-giveaway',
  type: 'SOQUEST',
  status: STATUS_TYPES.ACTIVE,
  name: 'Magic Store providao exclusive 5000 giveaway',
  index: 0,
  content: {
    type: ACTION_TYPES.SOQUEST,
    metadata: {
      title: 'Magic Store & ProviDAO $5,000 Giveaway: Win $PRD Tokens Now!',
      description:
        'Join the exclusive Magic Store & ProviDAO raffle and stand a chance to win 2 $PRD tokens worth $250 each. Complete the campaign for your entry. 10 winners, $5,000 prize pool.',
      keywords:
        'Magic Store, ProviDAO, Giveaway, $PRD Tokens, Exclusive Raffle, $5,000 prize pool, campaign, win, entry, ProviDAO campaign, Magic Square.',
    },
    config: {
      key: 'a5344a9defb8f3454438cf4207bfd648abf5',
      scode: 'MagicSquare',
      ccode: 'ZdcbG7eAxy',
      // leaderboardId: '65006d340a97bb81ff7e6371',
    },
  },
};
